import axios from 'axios'

import request from '@/utils/request'
/**
 *
 * @param {*} url
 * @param {*} name
 * @param {*} type
 */
export function downloadFile(url, fileId, type) {
    var globalApi = this.$globalApiAddress.replace('/api', '')
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = globalApi + url + +'?fileId=' + fileId
    document.body.appendChild(link)
    link.click()
  }
  
   
  export function parseLocalDate(time) {
    // console.log(time)
    const timestamp = Date.parse(time)
    // console.log(timestamp)
    // console.log(new Date(timestamp))
    // console.log(new Date(timestamp).toLocaleDateString().replaceAll('\/', '-'))
    return new Date(timestamp).toLocaleDateString().replaceAll('/', '-')
  }
  export async function  getImageFile(url) {
    let blobUrl = null;
    let   response = await request({
      baseURL: process.env.VUE_APP_BASE_API,
      method: 'get',
      url: url,
      responseType: 'blob',
      headers :{
        'Access-Control-Allow-Origin':'*'
      }
    })
    //console.log( "getImageFile response",  response)
    
    // .then(function (response) {
    //   //console.log("getImageFile",response)
    //   const blob = response.data;
    //   const reader = new FileReader();
    //   reader.onload = () => {
    //     blobUrl = reader.result;
    //   };
    //   reader.readAsDataURL(blob);
    //   //return blobUrl
    // });
  }

// 获取图片转base64
export function getBase64(file) {
    //console.log("getBase64",file)
    return new Promise(function(resolve, reject) {
      const reader = new FileReader()
      let imgResult = ''
      reader.readAsDataURL(file)
      reader.onload = function() {
        imgResult = reader.result
      }
      reader.onerror = function(error) {
        reject(error)
      }
      reader.onloadend = function() {
        resolve(imgResult)
      }
    })
  }
  export function base64ToBlob(base64String) {
    const params = base64String.split(',')// data:image/png;base64
    const byteCharacters = atob(params[1])
    const byteNumbers = new Array(byteCharacters.length)
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
      const byteArray = new Uint8Array(byteNumbers)
      return new Blob([byteArray], { type: (params[0].split(':')[1]).split(';')[0] })
    }
  }
  
  export function base64ToUrl(base64) {
    const blob = base64ToBlob(base64)
    return URL.createObjectURL(blob)
  }